import React, {useContext, useEffect, useState} from 'react';
import { Badge, AppBar, Toolbar, IconButton, Typography, Box, Select, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AppContext from './AppContext';
import { useNavigate } from 'react-router-dom';

const Header = ({ onToggleMenu }) => {
  const { ctxUser, ctxApp } = useContext(AppContext);
  const [ userapp, setUserapp ] = useState(null);
  const [ numBolita, setNumBolita ] = useState(0);
  const navigate = useNavigate();

  const name = ctxUser?.decodedToken?.name || 'Invitado';
  const comptes = ctxApp?.comptes;
  const monUserApp = ctxApp?.userapp || (comptes && comptes[0]?.userapp);

  const onAccountChange = (value) => {
    navigate('/' + value);
  };
  
  useEffect(() => {
    if (comptes) {
      setUserapp(monUserApp);
    }

    const num = (ctxApp?.numPendentTotal) || 0;
    setNumBolita(num);
      // eslint-disable-next-line
  }, [monUserApp, comptes, ctxApp?.numPendentTotal]);
  
  return (
    <AppBar position="static">
      <Toolbar>
        <IconButton edge="start" color="inherit" aria-label="menu" onClick={onToggleMenu}>
          <Badge 
            color="error" // Esto muestra la bolita en color rojo
            //variant="dot" // Usa "dot" para que sea una bolita sin número
            badgeContent={numBolita}
            invisible={numBolita===0} // Solo se muestra si hay notificaciones
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuIcon />
          </Badge>
        </IconButton>
        <Typography variant="h6">
          FDV Banc
        </Typography>
        {/* Nombre de cuenta centrado */}
        <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
          {userapp && 
          (<Select
            value={userapp}
            label="Compte"
            onChange={(e) => onAccountChange(e.target.value)}
          >
            {ctxApp.comptes.map((account) => (
              <MenuItem key={account.id} value={account.userapp}>
                {account.userapp}
              </MenuItem>
            ))}
          </Select>
          )}
        </Box>

        {/* Nombre de usuario alineado a la derecha */}
        <Box sx={{ textAlign: 'right' }}>
          <Typography variant="h7" component="div">
            {name}
          </Typography>
        </Box>      
      </Toolbar>
    </AppBar>   
  );
};

export default Header;
